import { render } from "./DNSdialog.vue?vue&type=template&id=0be5fffb&scoped=true"
import script from "./DNSdialog.vue?vue&type=script&lang=js"
export * from "./DNSdialog.vue?vue&type=script&lang=js"

import "./DNSdialog.vue?vue&type=style&index=0&id=0be5fffb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0be5fffb"

export default script